export enum ChannelTypeEnum {
    analog = 1,
    digital
}
